import { useInteractions } from "../../hooks/interactionsProvider";
import QuestionStep from "../steps/questionStep/questionStep";
import AnswersStep from "../steps/answersStep/answersStep";
import SettingsStep from "../steps/settingsStep/settingsStep";

export default function InteractionModalMain() {
    const { currentStep, Step1Component } = useInteractions();

    return (
        <main className="flex w-full h-full p-6">
            {currentStep === "time-and-type" && <Step1Component />}
            {currentStep === "question" && <QuestionStep />}
            {currentStep === "answers" && <AnswersStep />}
            {currentStep === "settings" && <SettingsStep />}
        </main>
    );
}
